import React from 'react';
import { Handle, Position } from 'reactflow';
import './EmailNode.css';

const EmailNode = ({ data, isConnectable, selected }) => {
    return (
        <div className={`email-node ${selected ? 'selected' : ''}`}>
            <Handle
                type="target"
                position={Position.Left}
                id="email-input"
                isConnectable={isConnectable}
                className="email-handle email-handle-input"
            />

            <div className="email-node-header">
                <span className="email-node-icon">📧</span>
                <span className="email-node-type">EMAIL</span>
            </div>
            
            <div className="email-node-content">
                <h4>{data.label}</h4>
                <div className="email-node-details">
                    <div className="email-subject">
                        <strong>Subject:</strong> {data.subject || 'No subject'}
                    </div>
                    {data.templateId && (
                        <div className="email-template">
                            <strong>Template:</strong> {data.templateName || 'Custom Template'}
                        </div>
                    )}
                    <div className="email-status">
                        {data.templateId ? '✅ Template Set' : '⚠️ No Template'}
                    </div>
                </div>
            </div>

            <Handle
                type="source"
                position={Position.Right}
                id="email-output"
                isConnectable={isConnectable}
                className="email-handle email-handle-output"
            />
        </div>
    );
};

export default EmailNode;
